/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilityDayModelAvailibilityModel } from '../../models/availability-day-model-availibility-model';
import { PractitionerAvailabilityRequestModel } from '../../models/practitioner-availability-request-model';

export interface PractitionerFindrAvailabilityPost$Params {
      body?: PractitionerAvailabilityRequestModel
}

export function practitionerFindrAvailabilityPost(http: HttpClient, rootUrl: string, params?: PractitionerFindrAvailabilityPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<AvailabilityDayModelAvailibilityModel>> {
  const rb = new RequestBuilder(rootUrl, practitionerFindrAvailabilityPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<AvailabilityDayModelAvailibilityModel>;
    })
  );
}

practitionerFindrAvailabilityPost.PATH = '/PractitionerFindr/Availability';
